import { useMemo } from 'react'
import { IPalletLogItem } from '../../../../modules/API/Pallets/models/palletLog'
import CardFlat from '../../../../generic/ui/card-flat/CardFlat'
import AppleIcon from '../../../icons/IconLib/AppleIcon'
import CalendatDay from '../../../icons/IconLib/CalendarIcon'
import PackageIcon from '../../../icons/IconLib/PackageBoxIcon'
import TimeIcon from '../../../icons/IconLib/ClockIcon'
import ScaleIcon from '../../../icons/IconLib/ScaleIcon'
import UserIcon from '../../../icons/IconLib/UserIcon'

const DATE_FORMATTER = new Intl.DateTimeFormat('he-IL', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
})

const TIME_FORMATTER = new Intl.DateTimeFormat('he-IL', {
  hour: '2-digit',
  minute: '2-digit',
})

const formatDateTime = (iso: string): { date: string; time: string } => {
  try {
    const d = new Date(iso)
    return { date: DATE_FORMATTER.format(d), time: TIME_FORMATTER.format(d) }
  } catch {
    return { date: '—', time: '—' }
  }
}

type Props = IPalletLogItem & {
  workerName?: string
}

const PalletLogItem = ({
  Time,
  ProductDesc,
  VarietyDesc,
  SizeID,
  WeightNeto,
  workerName,
  Quantity,
}: Props) => {
  const { date, time } = useMemo(() => formatDateTime(Time), [Time])



  return (
    <CardFlat.Root>
      <CardFlat.Row>
        <CardFlat.Item>
          <CardFlat.ItemIcon>
            <CalendatDay />
          </CardFlat.ItemIcon>
          <CardFlat.ItemLabel>תאריך</CardFlat.ItemLabel>
          <CardFlat.ItemValue>{date}</CardFlat.ItemValue>
        </CardFlat.Item>

        <CardFlat.Item>
          <CardFlat.ItemIcon>
            <TimeIcon />
          </CardFlat.ItemIcon>
          <CardFlat.ItemLabel>שעה</CardFlat.ItemLabel>
          <CardFlat.ItemValue>{time}</CardFlat.ItemValue>
        </CardFlat.Item>

        
      </CardFlat.Row>
      <CardFlat.Row>
        <CardFlat.Item>
          <CardFlat.ItemIcon>
            <AppleIcon />
          </CardFlat.ItemIcon>
          <CardFlat.ItemLabel>פריט</CardFlat.ItemLabel>
          <CardFlat.ItemValue>{`${ProductDesc?.trim()} ${VarietyDesc?.trim()} ${SizeID?.trim()}`}</CardFlat.ItemValue>
        </CardFlat.Item>


        
      </CardFlat.Row>
      <CardFlat.Row>
      <CardFlat.Item>
          <CardFlat.ItemIcon>
            <PackageIcon />
          </CardFlat.ItemIcon>
          <CardFlat.ItemLabel>כמות</CardFlat.ItemLabel>
          <CardFlat.ItemValue>{Quantity}</CardFlat.ItemValue>
        </CardFlat.Item>
      <CardFlat.Item>
          <CardFlat.ItemIcon>
            <ScaleIcon />
          </CardFlat.ItemIcon>
          <CardFlat.ItemLabel>משקל נטו</CardFlat.ItemLabel>
          <CardFlat.ItemValue>{WeightNeto.toFixed(2)}</CardFlat.ItemValue>
        </CardFlat.Item>
      </CardFlat.Row>
      <CardFlat.Divider />
      {workerName && (
          <CardFlat.Item>
            <CardFlat.ItemIcon>
              <UserIcon />
            </CardFlat.ItemIcon>
            <CardFlat.ItemLabel>עובד</CardFlat.ItemLabel>
            <CardFlat.ItemValue>{workerName}</CardFlat.ItemValue>
          </CardFlat.Item>
        )}
      
    </CardFlat.Root>
  )
}

export default PalletLogItem
